import styled from "styled-components";

export const RadioBtnsStyled = styled.div`
  margin-top: 12px;
  width: 100%;

  overflow-y: hidden;

  & > .pay-price {
    border-radius: 10px;
    width: 100%;
    background-color: #2a2e43;
    text-align: center;
    color: white;
    font-weight: bold;
    padding: 5px;
  }

  .input-price {
    width: 100%;
    padding: 2px 6px;
    border-radius: 8px;
    background-color: ${({ dark }) => (dark ? "#eaebed" : "#ffffff")};

    height: 26px;
  }

  .price-toman {
    position: absolute;
    height: 100%;
    display: flex;
    align-items: center;
    left: 8px;
    top: 0;
  }

  .bimeh-img {
    width: 50px
  }
`;
